import './inProgressStatement.css'

function InProgressStatement() {
   return (
      <div className='inProgressStatement__container'>
         We’re working on this page right now!
         <br />
         <br />
         Check out our other exciting content in the meantime
         <br />
         <br />
         <br />
         <br />
      </div>
   )
}

export default InProgressStatement